/* 'IN THE WILD' VIEW MORE — 카페24 `styling.js` 의 `openMoreModal`/`openDetailModal` 이식.
 *
 * 흐름: VIEW MORE → 전체 그리드 모달 → 항목 클릭 → 상세 슬라이드 뷰어(그 위에 겹친다).
 *
 * ⚠️⚠️ **데이터는 DOM 에서 읽는다.** Liquid 로 모달 마크업을 한 벌 더 찍지 않는다 —
 *    그러면 카드가 두 번 렌더돼 이미지가 두 배로 받아지고, 블록을 고쳤을 때 두 곳이 갈린다.
 * ⚠️ **카페24의 ALL / VIDEOS 탭은 넣지 않았다.** 그 탭은 항목이 영상인지로 거르는데
 *    우리 블록에는 영상 필드가 자체가 없다(이미지 하나뿐). 눌러도 늘 빈 결과가 나오는
 *    탭을 만들면 고장으로 보인다. 블록에 영상을 넣게 되면 그때 탭을 함께 살릴 것.
 * ⚠️ Swiper 는 슬라이더 섹션이 이미 불러온다 — 여기서 다시 넣지 않는다.
 * ⚠️ 모달은 `document.body` 바로 밑에 붙인다. 섹션 안에 두면 조상의 `transform`·`overflow`
 *    가 `position: fixed` 를 가둔다.
 */
(function () {
  if (window.__ntNisModal) return;
  window.__ntNisModal = true;

  var ICON_CLOSE =
    '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 37 37" fill="none" aria-hidden="true"><path d="M10.298 26.702C10.1655 26.5696 10.0772 26.4124 10.0331 26.2303C9.98896 26.0537 9.98896 25.8744 10.0331 25.6923C10.0772 25.5157 10.1628 25.3668 10.2897 25.2454L17.0351 18.5L10.2897 11.7546C10.1628 11.6332 10.0772 11.4843 10.0331 11.3077C9.98896 11.1311 9.98896 10.9518 10.0331 10.7697C10.0772 10.5876 10.1655 10.4304 10.298 10.298C10.4304 10.1655 10.5849 10.0772 10.7614 10.0331C10.9435 9.98896 11.1228 9.98896 11.2994 10.0331C11.476 10.0772 11.6305 10.1628 11.7629 10.2897L18.5 17.0351L25.2371 10.298C25.3695 10.1655 25.524 10.0772 25.7006 10.0331C25.8772 9.98896 26.0537 9.98896 26.2303 10.0331C26.4068 10.0772 26.5613 10.1655 26.6938 10.298C26.8317 10.4304 26.9228 10.5876 26.9669 10.7697C27.011 10.9463 27.011 11.1228 26.9669 11.2994C26.9228 11.476 26.8345 11.6305 26.702 11.7629L19.9649 18.5L26.702 25.2371C26.8345 25.3695 26.92 25.5213 26.9586 25.6923C27.0028 25.8689 27.0028 26.0454 26.9586 26.222C26.92 26.4041 26.8317 26.5641 26.6938 26.702C26.5613 26.8345 26.4068 26.9228 26.2303 26.9669C26.0537 27.011 25.8772 27.011 25.7006 26.9669C25.524 26.9228 25.3695 26.8345 25.2371 26.702L18.5 19.9649L11.7629 26.7103C11.6305 26.8372 11.476 26.9228 11.2994 26.9669C11.1228 27.011 10.9463 27.011 10.7697 26.9669C10.5932 26.9228 10.4359 26.8345 10.298 26.702Z" fill="#1A1A1A"/></svg>';

  /* 닫기 라벨 — 정적 JS 라 Liquid `t` 필터를 쓸 수 없다. 섹션이 트리거 버튼에
     `data-nis-close-label` 로 번역문을 실어 보내면 여기서 읽는다.
     ⚠️ **문구를 여기 적지 말 것** — 스크린리더가 읽는 고객 노출 텍스트라 번역 대상이다.
     ⚠️ 속성이 없으면 라벨 없이 둔다. 틀린 언어를 읽어 주는 것보다 낫다. */
  var closeLabel = '';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* 카드 하나가 갖는 이미지 목록을 읽는다.
     섹션이 `data-nis-images` 에 **주소만** 실어 보낸다(모달용 큰 폭). 브라우저는 data 속성 안의
     주소를 받지 않으므로, 모달을 열 때 비로소 내려받는다.
     ⚠️ 속성이 없으면(한 장짜리 카드·구버전 테마) 카드 <img> 로 폴백한다 — 그 경우 동작이 예전과 같다. */
  function readCardImages(slide) {
    var card = slide.querySelector('.nis-card') || slide;
    var raw = card.getAttribute('data-nis-images');
    if (raw) {
      try {
        var list = JSON.parse(raw);
        if (list && list.length) return list;
      } catch (err) {
        /* 속성이 깨졌으면 조용히 폴백한다 — 모달이 안 열리는 것보다 한 장이라도 보이는 게 낫다. */
      }
    }
    var img = slide.querySelector('.nis-card__media img');
    if (!img) return [];
    return [{ src: img.currentSrc || img.src, srcset: img.getAttribute('srcset') || '' }];
  }

  /* 슬라이더 카드에서 항목을 읽는다. 캡션 오른쪽(상품명)을 제목으로 쓰고, 없으면 왼쪽. */
  function readItems(scope) {
    var out = [];
    var slides = scope.querySelectorAll('.nis-slide');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('.nis-card__media img');
      if (!img) continue;
      var right = slides[i].querySelector('.nis-card__right');
      var left = slides[i].querySelector('.nis-card__left');
      var rightText = right ? right.textContent.trim() : '';
      var leftText = left ? left.textContent.trim() : '';
      out.push({
        src: img.currentSrc || img.src,
        srcset: img.getAttribute('srcset') || '',
        alt: img.getAttribute('alt') || '',
        title: rightText || leftText,
        /* 그리드 모달의 썸네일은 위 src 를 쓰고, 상세 슬라이드는 이 목록을 쓴다. */
        images: readCardImages(slides[i]),
      });
    }
    return out;
  }

  var openCount = 0;

  function lockScroll() {
    openCount++;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    openCount = Math.max(0, openCount - 1);
    /* 모달 위에 모달이 열려 있으면 잠금을 풀지 않는다. */
    if (openCount === 0) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

  function close(modal) {
    if (!modal || modal.dataset.ntClosing) return;
    modal.dataset.ntClosing = '1';
    var at = stack.indexOf(modal);
    if (at !== -1) stack.splice(at, 1);
    unlockScroll();

    var content = modal.querySelector('.nis-modal__content');
    if (content) {
      content.style.animation = 'none';
      content.style.transition = 'transform 0.3s ease-out';
      content.style.transform = 'translateY(100%)';
    }
    modal.style.backgroundColor = 'transparent';
    modal.style.opacity = '0';

    setTimeout(function () {
      if (modal.parentNode) modal.parentNode.removeChild(modal);
      if (modal.ntRestoreFocus && modal.ntRestoreFocus.focus) modal.ntRestoreFocus.focus();
    }, 300);
  }

  /* 배경(빈 곳)을 눌러 닫는다.
     ⚠️ `mousedown` 이 배경에서 시작했을 때만 닫는다 — 안에서 드래그하다 배경에서 손을 떼면
        닫히면 안 된다(카페24가 같은 방어를 한다). */
  function bindBackdrop(modal) {
    var fromBackdrop = false;
    modal.addEventListener('mousedown', function (e) {
      fromBackdrop = e.target === modal;
    });
    modal.addEventListener(
      'touchstart',
      function (e) {
        fromBackdrop = e.target === modal;
      },
      { passive: true }
    );
    modal.addEventListener('click', function (e) {
      if (fromBackdrop && e.target === modal) close(modal);
      fromBackdrop = false;
    });
  }

  /* ⚠️⚠️ ESC 는 **맨 위 모달 하나만** 닫는다. 모달마다 리스너를 달았더니 한 번 눌렀을 때
     그리드와 상세가 **함께 닫혔다**(실측). 그래서 열린 순서를 쌓아 두고 마지막 것만 닫는다. */
  var stack = [];

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var top = stack[stack.length - 1];
    if (top) close(top);
  });

  function makeModal(cls) {
    var modal = document.createElement('div');
    modal.className = 'nis-modal' + (cls ? ' ' + cls : '');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    document.body.appendChild(modal);
    return modal;
  }


  /* 아래로 끌어 닫기 — 카페24 `styling.js` 의 `initPullToClose` 이식.
     ⚠️ **터치만** 건다(카페24와 같다). 마우스로 끌어 닫는 동작은 원본에 없고, 넣으면
        데스크톱에서 이미지를 드래그하려던 손짓이 모달을 닫아 버린다.
     ⚠️ 스크롤이 이미 내려간 목록 위에서는 시작하지 않는다 — 그리드를 훑어 내리려던 손짓이
        모달을 닫으면 안 된다(카페24는 `.grid-content.scrollTop > 0` 로 같은 방어를 한다).
     ⚠️ **가로가 더 크면 드래그를 포기한다** — 상세는 좌우 스와이프로 슬라이드를 넘긴다.
     ⚠️ 임계값은 화면 높이의 **30%**(원본 값). 넘으면 닫고, 못 넘으면 제자리로 되돌린다. */
  function initPullToClose(modal) {
    var content = modal.querySelector('.nis-modal__content');
    if (!content) return;

    var startY = 0;
    var startX = 0;
    var currentY = 0;
    var dragging = false;
    var vertical = false;

    function onStart(e) {
      var scrollable = e.target.closest ? e.target.closest('.nis-modal__grid, .nis-modal__body') : null;
      if (scrollable && scrollable.scrollTop > 0) return;

      startY = e.touches[0].clientY;
      startX = e.touches[0].clientX;
      dragging = true;
      vertical = false;

      content.style.transform = 'translateY(' + currentY + 'px)';
      content.style.animation = 'none';
      content.style.transition = 'none';
      modal.style.transition = 'none';
    }

    function onMove(e) {
      if (!dragging) return;
      var dy = e.touches[0].clientY - startY;
      var dx = e.touches[0].clientX - startX;

      if (!vertical) {
        if (Math.abs(dx) > Math.abs(dy)) {
          dragging = false;
          return;
        }
        vertical = true;
      }

      currentY = Math.max(0, dy);
      content.style.transform = 'translateY(' + currentY + 'px)';

      if (currentY > 0) {
        var progress = currentY / window.innerHeight;
        /* 그리드는 화면을 꽉 채워 뒤가 안 보이므로 투명도로, 상세는 배경색으로 흐린다
           (`.nis-modal--grid` 가 카페24 `view-modal` 자리다 — CSS 주석 참고). */
        if (modal.classList.contains('nis-modal--grid')) {
          modal.style.opacity = String(Math.max(0, 1 - progress));
        } else {
          modal.style.backgroundColor = 'rgba(0, 0, 0, ' + Math.max(0, 0.6 - progress * 1.5) + ')';
        }
      }
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;

      content.style.transition = 'transform 0.3s ease-out';
      modal.style.transition = 'background-color 0.3s ease, opacity 0.3s ease';

      if (currentY >= window.innerHeight * 0.3) {
        close(modal);
        return;
      }

      content.style.transform = 'translateY(0px)';
      modal.style.backgroundColor = '';
      modal.style.opacity = '';
      currentY = 0;
      setTimeout(function () {
        content.style.transition = '';
        modal.style.transition = '';
      }, 300);
    }

    content.addEventListener('touchstart', onStart, { passive: true });
    content.addEventListener('touchmove', onMove, { passive: true });
    content.addEventListener('touchend', onEnd);
  }

  function activate(modal) {
    lockScroll();
    bindBackdrop(modal);
    stack.push(modal);
    initPullToClose(modal);
    requestAnimationFrame(function () {
      modal.classList.add('is-active');
    });
    var closeBtn = modal.querySelector('.nis-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(modal);
      });
      closeBtn.focus();
    }
  }

  /* 한 카드의 이미지들을 슬라이드로 만든다.
     ⚠️ 첫 장만 `eager` 다 — 나머지를 함께 받으면 모달을 열자마자 N장이 내려온다. */
  function slidesHtml(item) {
    var list = item.images && item.images.length ? item.images : [{ src: item.src, srcset: item.srcset }];
    var html = '';
    for (var i = 0; i < list.length; i++) {
      html +=
        '<div class="swiper-slide"><img src="' +
        esc(list[i].src) +
        '"' +
        (list[i].srcset ? ' srcset="' + esc(list[i].srcset) + '"' : '') +
        ' alt="' +
        esc(item.alt || '') +
        '" loading="' +
        (i === 0 ? 'eager' : 'lazy') +
        '"></div>';
    }
    return html;
  }

  function openDetail(items, index, heading) {
    var item = items[index];
    if (!item) return;

    var modal = makeModal('nis-modal--detail');
    modal.setAttribute('aria-label', item.title || heading || '');
    modal.ntRestoreFocus = document.activeElement;

    modal.innerHTML =
      '<div class="nis-modal__content">' +
      '<div class="nis-modal__grabber-wrap"><div class="nis-modal__grabber"></div></div>' +
      '<div class="nis-modal__head"><h3>' +
      esc(item.title || heading || '') +
      '</h3><button type="button" class="nis-modal__close"' +
      (closeLabel ? ' aria-label="' + esc(closeLabel) + '"' : '') +
      '>' +
      ICON_CLOSE +
      '</button></div>' +
      '<div class="nis-modal__body">' +
      '<div class="swiper nis-detail"><div class="swiper-wrapper">' +
      slidesHtml(item) +
      '</div>' +
      '<div class="swiper-button-next"></div><div class="swiper-button-prev"></div>' +
      '<div class="swiper-pagination"></div></div>' +
      '</div></div>';

    activate(modal);

    /* ⚠️ 카드가 이미지를 한 장만 가지면 슬라이드도 하나다(칸을 다 채우지 않아도 된다).
       **Swiper 는 한 장이어도 점 하나와 죽은 화살표를 그리므로** 직접 감춘다 —
       누를 수 없는 컨트롤은 고장으로 보인다. 두 장 이상이면 그대로 둔다. */
    var detail = modal.querySelector('.nis-detail');
    if (detail.querySelectorAll('.swiper-slide').length < 2) {
      detail.classList.add('nis-detail--single');
    }

    if (typeof Swiper === 'function') {
      new Swiper(detail, {
        pagination: { el: modal.querySelector('.swiper-pagination'), type: 'bullets' },
        navigation: {
          nextEl: modal.querySelector('.swiper-button-next'),
          prevEl: modal.querySelector('.swiper-button-prev'),
        },
      });
    }
  }

  function openGrid(scope, heading, trigger) {
    var items = readItems(scope);
    if (!items.length) return;

    var modal = makeModal('nis-modal--grid');
    modal.setAttribute('aria-label', heading || '');
    modal.ntRestoreFocus = trigger;

    var cells = '';
    for (var i = 0; i < items.length; i++) {
      cells +=
        '<button type="button" class="nis-modal__cell" data-nis-index="' +
        i +
        '"><img src="' +
        esc(items[i].src) +
        '" alt="' +
        esc(items[i].alt) +
        '" loading="lazy"></button>';
    }

    modal.innerHTML =
      '<div class="nis-modal__content">' +
      '<div class="nis-modal__head"><h3>' +
      esc(heading || '') +
      ' (' +
      items.length +
      ')</h3>' +
      '<button type="button" class="nis-modal__close"' +
      (closeLabel ? ' aria-label="' + esc(closeLabel) + '"' : '') +
      '>' +
      ICON_CLOSE +
      '</button></div>' +
      '<div class="nis-modal__grid">' +
      cells +
      '</div></div>';

    activate(modal);

    modal.querySelector('.nis-modal__grid').addEventListener('click', function (e) {
      var cell = e.target.closest ? e.target.closest('.nis-modal__cell') : null;
      if (!cell) return;
      openDetail(items, parseInt(cell.getAttribute('data-nis-index'), 10), heading);
    });
  }

  /* 슬라이드 이미지를 누르면 상세 모달을 연다 — 카페24도 슬라이드 클릭이
     `openDetailModal(boardId)` 이다(`bindEventsToSlides`).
     ⚠️ 블록에 링크가 들어 있으면 **그대로 이동**시킨다 — 그 링크는 운영자가 일부러 넣은 것이라
        모달로 가로채면 설정한 곳으로 갈 방법이 없어진다.
     ⚠️ Swiper 의 `preventClicks` 가 기본 켬이라 슬라이드를 끌고 놓은 뒤의 클릭은 오지 않는다. */
  document.addEventListener('click', function (e) {
    var slide = e.target.closest ? e.target.closest('.nis-slide') : null;
    if (!slide) return;
    var scope = slide.closest('.nis');
    if (!scope) return;
    var link = e.target.closest('a[href]');
    if (link && link.getAttribute('href')) return;

    e.preventDefault();
    var more = scope.querySelector('[data-nis-more]');
    if (more) closeLabel = more.getAttribute('data-nis-close-label') || closeLabel;

    var slides = [].slice.call(scope.querySelectorAll('.nis-slide'));
    var index = slides.indexOf(slide);
    if (index < 0) return;
    var h = scope.querySelector('.nis-heading');
    openDetail(readItems(scope), index, h ? h.textContent.trim() : '');
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-nis-more]') : null;
    if (!btn) return;
    var scope = btn.closest('.nis');
    if (!scope) return;
    e.preventDefault();
    closeLabel = btn.getAttribute('data-nis-close-label') || closeLabel;
    var h = scope.querySelector('.nis-heading');
    openGrid(scope, h ? h.textContent.trim() : '', btn);
  });
})();
